import { Icon } from "@alm/flow-ds/components";
import React from "react";
import { NavLink } from "react-router-dom";
import MenuItem from "./MenuItem";

interface Props {
	name: string;
	icon?: string;
	to: string;
	match?: string;
	close?: () => void;
}

export default function MenuItemLink({ name, icon, to, match, close }: Props) {
	return (
		<MenuItem name={name}>
			<NavLink
				isActive={(_, location) =>
					match
						? location.pathname.startsWith(match)
						: location.pathname === to
				}
				to={to}
				activeClassName="menu__item--active"
				exact
				onClick={e => {
					e.stopPropagation();
					if (close) close();
				}}>
				{icon && (
					<Icon type={icon} weight="l" size="sm" fixedWidth></Icon>
				)}
				{name}
			</NavLink>
		</MenuItem>
	);
}
